import PageHeader from "../../../components/layout/PageHeader";
import PageContent from "../../../components/layout/PageContent";
import {DataTable, DataTableColumn, DataTableSortStatus, useDataTableColumns} from "mantine-datatable";
import PaginationFooter from "../../../components/pagination/PaginationFooter";
import {useEffect, useState} from "react";
import PlannedFailureAPI, {SearchQuery} from "../../../api/planned/failure/PlannedFailureAPI";
import Page from "../../../models/api/Page";
import {PlannedFailure} from "../../../api/planned/failure/PlannedFailure";
import {useSessionStorage} from "@mantine/hooks";
import CreatePlannedFailureModal from "./CreatePlannedFailureModal";
import {Button} from "@mantine/core";
import {useContextMenu} from "mantine-contextmenu";
import UpdatePlannedFailureModal from "./UpdatePlannedFailureModal";
import {PlannedFailureFilter} from "./PlannedFailureFilter";

const columns: DataTableColumn<PlannedFailure>[] = [
    {
        accessor: 'id',
        title: '#',
        toggleable: true,
        defaultToggle: false
    },

    {
        accessor: 'date',
        title: 'Data',
        sortable: true,
        draggable: true,
    },

    {
        accessor: 'location',
        title: 'Miejsce',
        sortable: true,
        draggable: true
    },

    {
        accessor: 'description',
        title: 'Opis',
        sortable: true,
        draggable: true
    },

    {
        accessor: 'daysLeft',
        title: 'Dni pozostało',
        sortable: true,
        draggable: true
    },

  {
    accessor: "isDone",
    title: "Zakończone",
    sortable: true,
    draggable: true,
    render: (record) => {
      return <>{record.isDone ? <i style={{color: 'green'}} className="fa fa-check"></i> : <i style={{color: 'red'}} className="fa fa-x"></i>}</>
    }
  }
];

export default function PlannedFailurePage() {
    const [query, setQuery] = useState<SearchQuery>({
      limit: 100,
      page: 0,
      isDone: false,
    });
    const [create, setCreate] = useState(false);
    const [edit, setEdit] = useState<PlannedFailure>();
    const { showContextMenu } = useContextMenu();

    const [sortStatus, setSortStatus] = useSessionStorage<DataTableSortStatus<PlannedFailure>>({
        key: 'PlannedFailure_SortStatus_2',
        defaultValue: {
            columnAccessor: 'date',
            direction: 'desc'
        }
    });

    const {effectiveColumns} = useDataTableColumns({key: "PlannedFailure_table", columns});

    const [page, setPage] = useState<Page<PlannedFailure>>();

    const [fetch, setFetch] = useState(false);

    const reload = () => {
        setFetch(true);

        PlannedFailureAPI.search(query)
            .then(setPage)
            .finally(() => setFetch(false));
    };

    useEffect(reload, [query]);

    useEffect(() => {
      setQuery({...query, sortBy: sortStatus.sortKey, sortDir: sortStatus.direction });
      // eslint-disable-next-line
    }, [sortStatus]);

    return (
        <>
            <PageHeader
                title="Planowane awarie"
                pageTitle="Planowane awarie"
                action={
                    <Button onClick={() => setCreate(true)}>
                        Nowa
                    </Button>
                }
            />

            <PageContent>
                <PlannedFailureFilter query={query} setQuery={setQuery}/>

                <DataTable
                    mt="xl"
                    height="60vh"
                    withColumnBorders
                    styles={{header: {background: 'white'}}}
                    striped
                    highlightOnHover
                    backgroundColor={'transparent'}
                    fetching={fetch}
                    minHeight={150}
                    noRecordsText={"Pusto..."}
                    loaderBackgroundBlur={1}
                    columns={effectiveColumns}
                    records={page?.content ?? []}
                    style={{marginBottom: '50px'}}
                    // selectedRecords={selectedDevices}
                    // onSelectedRecordsChange={setSelectedDevices}
                    sortStatus={sortStatus}
                    onSortStatusChange={(sortStatus) => setSortStatus(sortStatus)}
                    storeColumnsKey="PlannedFailure_table"
                    onRowContextMenu={(data) => {
                        showContextMenu([
                            {
                                title: 'Edycja',
                                key: 'edit-pf',
                                onClick: () => {
                                    setEdit(data.record);
                                }
                            },
                        ])(data.event)
                    }}
                />

                <PaginationFooter
                    page={page}
                    setLimit={(limit: number) => setQuery({...query, limit})}
                    setPageNumber={(pageNumber: number) => setQuery({...query, page: pageNumber})}
                    pageNumber={query.page}
                    limit={query.limit}
                />
            </PageContent>

            <CreatePlannedFailureModal
                opened={create}
                onClose={() => {
                    reload();
                    setCreate(false);
                }}
            />

            <UpdatePlannedFailureModal
                plannedFailure={edit}
                onClose={() => {
                    setEdit(undefined);
                    reload();
                }}
            />
        </>
    )
}